import React from 'react'
import { connect, useDispatch } from 'react-redux'

import { BuildingInterface, setByFlag } from '@store/actionSlices/building'
import { RootStateType } from '@store/store'
import { ExtendedUnitFilterOptions } from '@store/types'

import DropDown from '@components/dropdown'

import { Level } from '@api/building'
import { StatusLabels } from '@api/config'

import { Unit } from '@adUtilities/types/apartment'

const AVAILABLE_STATUS = 'available'

interface Props {
  building: BuildingInterface
  blocks: string[]
  unitFilter: ExtendedUnitFilterOptions
  statusLabels: StatusLabels
}
function BlockDropdown({ building, unitFilter, blocks, statusLabels }: Props) {
  const dispatch = useDispatch()
  const buildingOptions = React.useMemo(
    () =>
      blocks.map((item) => ({
        label: item,
        value: item,
      })),
    [blocks]
  )
  const getFirstLevel = React.useCallback(
    (selectedBlock: string) => {
      const levelList: Level[] = [...building.levels]

      const filteredLevels = levelList.filter((lvl) =>
        unitFilter.showAvailable
          ? lvl.data.some(
              (unit: Unit) =>
                unit.metas.status === statusLabels?.available ||
                unit.metas.status === AVAILABLE_STATUS
            )
          : true
      )

      const firstLevel = filteredLevels.find((lvl) =>
        lvl.data.some((unit) => unit.blockId === selectedBlock)
      )

      return firstLevel?.level || filteredLevels[0]?.level
    },
    [building.levels, statusLabels, unitFilter.showAvailable]
  )
  const onChangeBlock = React.useCallback(
    (value: string) => {
      const firstLevel = getFirstLevel(value)
      dispatch(setByFlag({ flag: 'activeBlock', value }))
      dispatch(setByFlag({ flag: 'activeLevel', value: firstLevel }))
      dispatch(setByFlag({ flag: 'activeUnit', value: '' }))
    },
    [dispatch, getFirstLevel]
  )

  return (
    <DropDown
      onSelect={onChangeBlock}
      items={buildingOptions}
      value={building.activeBlock || buildingOptions[0].value}
      className="py-2"
      buttonRadius="rounded-[7px]"
      buttonRadiusClasses="rounded-tl-[7px] rounded-tr-[7px]"
      optionRadiusClasses="rounded-bl-[7px] rounded-br-[7px]"
    />
  )
}

export default connect(
  ({
    unitFilter,
    building,
    projectConfig: { statusLabels },
  }: RootStateType) => ({
    unitFilter,
    building,
    statusLabels,
  })
)(BlockDropdown)
